import * as React from 'react';
import * as cx from 'classnames';

import SuperCritical from 'lib/supercritical';

import { WartsilaEnrichmentsSummaryCard, SummaryCardContent } from './summaryCard';

import { EstimateDetailsCondensedView } from './estimateDetailsView';
import { MapView } from './mapview';

export interface WartsilaEnrichmentsSummaryCardViewProps {
    model : WartsilaEnrichmentsSummaryCard;
    extraClassName? : string;
}

export const WartsilaEnrichmentsSummaryCardView = SuperCritical(({ model: m, extraClassName } : WartsilaEnrichmentsSummaryCardViewProps) =>
    m.Content() && <ContentView model={m.Content()!} className={extraClassName} />
);

const ContentView = SuperCritical(({ model: m, className } : { model : SummaryCardContent, className? : string }) =>
    <div className={cx('wartsila-enrichments summary-card pc-card', className, {
        'full-view': m.HasSuccessfulQuery()
    })}>
        <div className="wartsila-logo icon-wartsila-logo" />
        <div className="summary-main">
            <div className="enrichments-header">
                <a className="enrichments-title" href={`#!wartsilaenrichments?id=${m.Id}`}>
                    W&#x00e4;rtsil&#x00e4; Enrichments
                </a>
            </div>
            {m.HasSuccessfulQuery() &&
                // For the summary card, only show estimate details and map in case we have a
                // successful query. If the user's wondering why we don't have an estimate to display,
                // they can drill into the standalone wartsilaenrichments page to see error details etc.
                <div>
                    <EstimateDetailsCondensedView model={m.EstimateDetails} />
                    <MapView model={m.Map} />
                </div>
            }
            <LoadingIndicator model={m} />
        </div>
    </div>
);

const LoadingIndicator = SuperCritical(({ model: m } : { model : SummaryCardContent }) =>
    m.Loading() ? <div className="enrichments-loading-indicator" /> : null
);



// WEBPACK FOOTER //
// ./apps/wartsila/wartsilaenrichments/summaryCardView.tsx